import { render, staticRenderFns } from "./GifteeForBusinessIcon.vue?vue&type=template&id=76b1e4b0&"
import script from "./GifteeForBusinessIcon.vue?vue&type=script&lang=js&"
export * from "./GifteeForBusinessIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports